import {ExecuteRequest} from "core/glambox/GlamboxApi";
import {GlamboxEndpoints} from "core/glambox/GlamboxEndpoints";
import React from "react";
import {connect} from "react-redux";
import LogBarView from "views/pages/LogBarView";
import PartnerStyles from "views/development/PartnerStyles.module.scss";

export class StatusInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dateFrom: null,
      qtVendas: 0,
      qtMinimaVendas: 0,
      vendasNecessarias: 0,
      monthsCount: 0,
      influencerStatus: props.partnerInfo.influencerStatus || ''
    };
  }

  componentDidMount() {
    this.pastDate();
    this.getQtVendas();
  }


  pastDate = () => {
    let dateFrom = new Date();
    dateFrom.setMonth(dateFrom.getMonth() - 3);
    dateFrom.setDate(1);

    let month = dateFrom.getMonth() + 1;

    let convertedDate = dateFrom.getDate() + "/" + month;

    this.setState({
      dateFrom: convertedDate
    });
  }

  strToDate = (date) => {
    let startDate = new Date(date);
    let month = (startDate.getMonth() + 1);
    let convertedDate = startDate.getFullYear() + "/" + month + "/" + startDate.getDate();

    return convertedDate;
  }

  getQtVendas = () => {
    let dateFrom = new Date();
    dateFrom.setMonth(dateFrom.getMonth() - 3);
    dateFrom.setDate(1);
    dateFrom = this.strToDate(dateFrom);

    let dateTo = new Date();
    dateTo = this.strToDate(dateTo);

    const {token} = this.props;

    ExecuteRequest(
      GlamboxEndpoints.Partner.getSalesCount,
      {
        personId: token.personId,
        dateFrom: dateFrom,
        dateTo: dateTo
      },
      "GET",
      {
        Authorization: token.Authorization
      },
      null,
      (response) => {
        const {statusCode, result} = response;

        if (statusCode === 200) {
          if (result.result) {
            this.setState({
              qtVendas: result.result.totalVendas
            });
          }

          this.getQtdMinimaVendas();

        }
      }
    );

  }

  getQtdMinimaVendas = () => {
    const {token} = this.props;

    ExecuteRequest(
      GlamboxEndpoints.Partner.getSalesQuantityRule,
      null,
      "GET",
      {
        Authorization: token.Authorization
      },
      null,
      (response) => {
        const {statusCode, result} = response;
        if (statusCode === 200) {
          this.setState({
            qtMinimaVendas: result.result.minimumSales,
            monthsCount: result.result.monthsCount
          }, () => {
            this.setVendasNecessarias();
          });
        }
      }
    );
  }

  setVendasNecessarias = () => {
    const {qtMinimaVendas, qtVendas} = this.state;
    const abaixoDaMeta = qtVendas < qtMinimaVendas;
    const vendasNecessarias = qtMinimaVendas - qtVendas;

    this.setState({
      vendasNecessarias: (abaixoDaMeta) ? (vendasNecessarias) : qtMinimaVendas
    });
  }

  renderInfo = () => {
    const {qtVendas, qtMinimaVendas, monthsCount, influencerStatus} = this.state;
    let pStatus = influencerStatus === 'Glampartner' ? (qtVendas >= qtMinimaVendas ? 'Glampartner VIP' : 'Glampartner') : influencerStatus;
    let statusDescText = <h3 className={PartnerStyles["status"]}>Você <span
      style={{textTransform: "lowercase"}}>é uma</span> {pStatus}</h3>
    if (qtVendas < qtMinimaVendas) {

      if (influencerStatus === 'Glampartner') {
        return (
          <>
            {statusDescText}
            <p>Nos últimos {monthsCount} meses você teve {qtVendas} usos do cupom</p>
            <p>Ainda faltam <b>{qtMinimaVendas - qtVendas}</b> usos de cupom para se tornar uma <b>Glampartner
              VIP</b> no mês que vem! </p>
          </>
        );
      } else {
        return (
          <>
            {statusDescText}
            <p>Nos últimos {monthsCount} meses você teve {qtVendas} usos do cupom</p>
            <p><b>Atenção!</b> Ainda faltam <b>{qtMinimaVendas - qtVendas}</b> usos de cupom para manter seu status
              de <b>Glampartner VIP</b> no próximo mês! </p>
          </>
        );
      }


    } else {
      if (influencerStatus === 'Glampartner') {
        return (
          <>
            {statusDescText}
            <p>Nos últimos {monthsCount} meses você teve {qtVendas} usos do cupom</p>
            <p>Parabéns! Com esse resultado de vendas, no próximo mês você será uma <b>Glampartner VIP</b>!</p>
          </>
        );
      } else {
        return (
          <>
            {statusDescText}
            <p>Nos últimos {monthsCount} meses você teve {qtVendas} usos do cupom</p>
            <p>Mandou bem! Com esse resultado você continuará sendo uma <b>Glampartner VIP</b> no mês que vem. </p>
          </>
        );
      }

    }

  }

  renderProgressBar = () => {
    const {qtVendas, qtMinimaVendas} = this.state;
    const abaixoDaMeta = qtVendas < qtMinimaVendas;
    const qtVendasDisplay = (abaixoDaMeta && qtVendas > 0) ? qtVendas : null;

    let progress = 0;
    if (abaixoDaMeta && qtVendas > 0) {
      progress = (qtVendas / qtMinimaVendas * 100);
    } else if (!abaixoDaMeta) {
      progress = (qtMinimaVendas / qtMinimaVendas * 100);
    }

    let backgroundColor = (progress > 0) ? "#ff7da5" : "transparent";

    return (
      <>
        <LogBarView value={qtVendas}/>
      </>
    );
  };

  render() {
    const {qtMinimaVendas, monthsCount, qtVendas} = this.state;

    let mensagem = `Status VIP requer ao menos ${qtMinimaVendas} usos de cupom para Glambox nos últimos ${monthsCount} meses`;

    return (
      <>
        {this.renderInfo()}

        {this.renderProgressBar()}

        <p style={{marginTop: '10px'}}>
          <small>
            {mensagem}
          </small>
        </p>
      </>
    );
  }

}

const mapStateToProps = (state) => ({
  partnerInfo: state.partnerInfo.data,
  token: state.token.data
});

const mapDispatchToProps = (dispatch) => ({});

StatusInfo = connect(
  mapStateToProps,
  mapDispatchToProps
)(StatusInfo);
